// Blockchain constants
export const KAIA_RPC_URL =
  "https://8217.rpc.thirdweb.com/f00f9bfe16df51cdf033331e0d62ca76";

// Contract addresses
export const KAIAPAY_VAULT_ADDRESS =
  "0x9BA9bF3edaE56186fD5c342092Db47dd5B2FEd3b";
export const USDT_ADDRESS = "0xd077A400968890Eacc75cdc901F0356c943e4fDb";
export const KAIA_ADDRESS = "0x0000000000000000000000000000000000000000"; // Native KAIA
